import axios from 'axios';
import { Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { POSTBOX_DELIVERY } from '../../constants/paths/api';
import { getPostboxDeliveryDataModel } from '../../helpers/apiHelpers/postboxDeliveryHelpers';
import { RootState } from '../../store';
import SuccessOrFailure from '../successOrFailure';
import { postboxDeliveryInitialValues, postboxDeliverySchema } from './postboxDelivery.schema';
import * as StyledPostboxDelivery from './postboxDelivery.styles';
import PostboxDeliveryFormFields from './postboxDeliveryFormFields';

interface Props {
	noScroll?: boolean;
}

const PostboxDelivery: FC<Props> = ({ noScroll }) => {
	const { t } = useTranslation('generalForm');
	const pageReducer = useSelector((store: RootState) => store.pageReducer);
	const { page } = pageReducer;
	const [hasSubmitted, setHasSubmitted] = useState(false);
	const [error, setError] = useState(false);

	const onSubmit = values => {
		const { SendEmailTo } = page.Values;

		const model = getPostboxDeliveryDataModel(values, SendEmailTo);

		axios
			.post(POSTBOX_DELIVERY, model)
			.then(response => {
				setHasSubmitted(true);
				setError(response.data.error);
				if (!noScroll) window.scrollTo(0, 0);
			})
			.catch(() => {
				setHasSubmitted(true);
				setError(true);
				if (!noScroll) window.scrollTo(0, 0);
			});
	};

	return (
		<StyledPostboxDelivery.Wrapper>
			{!hasSubmitted && (
				<Formik
					initialValues={postboxDeliveryInitialValues}
					enableReinitialize
					validationSchema={postboxDeliverySchema}
					onSubmit={onSubmit}>
					{({
						values,
						handleSubmit,
						setFieldTouched,
						setFieldValue,
						isSubmitting,
						status,
						touched,
						errors,
					}) => (
						<form onSubmit={handleSubmit}>
							{!status && (
								<PostboxDeliveryFormFields
									values={values}
									setFieldTouched={setFieldTouched}
									setFieldValue={setFieldValue}
									isSubmitting={isSubmitting}
									touched={touched}
									errors={errors}
								/>
							)}
						</form>
					)}
				</Formik>
			)}
			<SuccessOrFailure
				hasSubmitted={hasSubmitted}
				success={!error}
				messageArray={[
					t('successMessagePostboxDelivery1'),
					t('successMessagePostboxDelivery2'),
					t('successMessagePostboxDelivery3'),
				]}
			/>
		</StyledPostboxDelivery.Wrapper>
	);
};

export default PostboxDelivery;
